import React, { useState, useEffect } from 'react';
import { Row, Col, DropdownToggle, DropdownItem, DropdownMenu, Dropdown, Button } from 'reactstrap';
import { faCogs, faTruckLoading, faTruck, faCheck, faSave, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment/moment';

//Api
import ManutencaoOrdemColeta_api from '../../../api/ManutencaoOrdemColeta_api';
import programacaoColeta_api from '../../../api/programacaoColeta_api';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import TabelaListagemGeradores from './TabelaListagemGeradores';
import Loading from '../../../components/Loading/Loading';
import ColetaExtraordinaria from './components/ColetaExtraordinadia';
import TransbordoETransferencia from './components/TransbordoETransferencia';
//Helpers
import { showMessage } from '../../../helpers/message';

//Estado inicial dos dados para manutenção da ordem
function initialState() {
    return {
        dataColeta: "",
        descricao: "",
        status: "",
        tbDestino_Id: "",
        placaVeiculo: "",
        tbVeiculos_Id: "",
        tbUsuarios_Operador_Id: "",
        items: [],
    }
}

export default function EditarManutencaoColeta({ id, btnVoltar }) {

    //Estado de controle de exibição do modal
    const [openModal, setOpenModal] = useState(false);
    
    //Troca o estado de exibição do modal
    const toggleModal = () => setOpenModal(!openModal);
    
    //Controle o dropdown do botão de ações
    const [openBtnConfig, setOpenBtnConfig] = useState(false);
    
    //Controla o loading na tela
    const [loading, setLoading] = useState(false);
    
    //Faz a troca da aparição do dropdown na tela
    const toggleBtnConfig = () => setOpenBtnConfig(!openBtnConfig);
    
    //Armazena os dados da ordem selecionada para manutenção
    const [ordem, setOrdem] = useState(initialState);
    
    //Armazena os dados do select de destinos
    const [destinos, setDestinos] = useState([]);
    
    //Armazena os dados do select de motoristas
    const [motoristas, setMotoristas] = useState([]);
    
    //Faz o controle dos dados que vão ser mostrados no modal por meio da ação indicada
    const [acao, setAcao] = useState("");
    
    //Salva os dados da alteração dos selects
    const salvarManutencao = () => {
        setLoading(true);
        ManutencaoOrdemColeta_api.AtualizarDadosColeta(ordem).then(response => {
            showMessage("Sucesso", "Dados salvos com sucesso", "success", null);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false))
    }

    //Carrega os dados da ordem e os destinos , motoristas disponiveis para ela e as modalidades da coleta extraordinaria
    useEffect(() => {
        setLoading(true);
        ManutencaoOrdemColeta_api.GetItem(id).then(response => {
            //Carrega os destinos disponiveis
            programacaoColeta_api.GetDestinosDisponiveisPorVeiculoEOrdem(response.data.tbVeiculos_Id, id).then(destinosD => {
                const options = destinosD.data.map(destino => { return { value: destino.id, text: destino.fantasia } });
                setDestinos(options);
            }).catch(e => showMessage("Aviso", e.message, "error", null));

            //Carrega os motoristas disponiveis
            programacaoColeta_api.GetMotoristasDisponiveis(id).then(motoristasD => {
                const options = motoristasD.data.map(motorista => { return { value: motorista.id, label: motorista.nome } });
                setMotoristas(options);

                response.data.tbMotoristaSelected = options.filter(value => value.value === response.data.tbUsuarios_Operador_Id)[0];
                setOrdem(response.data);

            }).catch(e => showMessage("Aviso", e.message, "error", null));

        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));

    }, []);
    
    //OnChange para o campo de destino da ordem
    const onChangeDestino = (e) => {
        const { name, value } = e.target;
        setOrdem({
            ...ordem,
            [name]: value
        })
    }
    
    //OnChange para o campo de motorista da ordem
    const onChangeMotorista = (e, select) => {
        setOrdem({
            ...ordem,
            [select.name]: e,
            tbUsuarios_Operador_Id: e.value
        })
    }
    
    //Retorna o conteudo da ação para o model especificado
    const finalizarOrdem = () => {
        setLoading(true);
        ManutencaoOrdemColeta_api.FinalizarOrdemColetaManual(ordem.id).then(response => {
            showMessage("Sucesso", "Ordem de Coleta finalizada com sucesso! As coletas pendentes e as que não foram destinadas foram transferidas para a ordem de hoje.", "success", btnVoltar);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
            .finally(f => setLoading(false));
    }
    
    //Botão de configurações da manutenção
    const BtnConfig = () => {
        return (
            <Dropdown isOpen={openBtnConfig} toggle={toggleBtnConfig}>
                <DropdownToggle caret className='bg-primary border-0'>
                    <FontAwesomeIcon icon={faCogs} />  Ações
                </DropdownToggle>
                <DropdownMenu container="body">
                    {ordem.status != "Finalizada" &&
                        <DropdownItem onClick={finalizarOrdem}>
                            <FontAwesomeIcon icon={faCheck} /> Finalizar ordem
                        </DropdownItem>
                    }
                    <DropdownItem onClick={() => {
                        toggleModal();
                        setAcao("Adicionar coleta extraordinária");
                    }}>
                        <FontAwesomeIcon icon={faPlus} /> Adicionar coleta extraordinária
                    </DropdownItem>
                    <DropdownItem onClick={() => {
                        toggleModal();
                        setAcao("Transbordo de carga");
                    }}>
                        <FontAwesomeIcon icon={faTruck} /> Transbordo de carga
                    </DropdownItem>
                    <DropdownItem onClick={() => {
                        toggleModal();
                        setAcao("Transferência de coletas pendentes");
                    }}>
                        <FontAwesomeIcon icon={faTruckLoading} /> Transferência de coletas pendentes
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }

    return (
        <MainCard btnVoltar={btnVoltar} BtnAction1={BtnConfig} >
            {loading && <Loading />}
            {
                acao === "Adicionar coleta extraordinária" && ordem && (
                    <ColetaExtraordinaria ordem={ordem} setOrdem={setOrdem} setLoading={setLoading} toggleModal={toggleModal} openModal={openModal} />
                )
            }
            {(acao === "Transbordo de carga" || acao === "Transferência de coletas pendentes") && ordem && (
                <TransbordoETransferencia acao={acao} toggleModal={toggleModal} openModal={openModal} ordem={ordem} setLoading={setLoading} btnVoltar={btnVoltar} />
            )}
            <div className='formData'>
                <Row>
                    <Col md="12" lg="4">
                        <TextField label={"* Data"} name={"dataColeta"} disabled value={moment(ordem.dataColeta).format("YYYY/MM/DD")} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label={"* Descrição"} disabled value={ordem.descricao} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label={"* Status"} disabled value={ordem.status} />
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="4">
                        <TextField label={"* Veículo"} disabled value={ordem.placaVeiculo} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label={"* Destino"} type={"select"} value={ordem.tbDestino_Id} name={"tbDestino_Id"} options={destinos} onChange={onChangeDestino} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label={"* Motorista"} type={"select"} searchable value={ordem.tbMotoristaSelected} name={"tbMotoristaSelected"} options={motoristas} onChange={onChangeMotorista} />
                    </Col>
                </Row>
            </div>
            <TabelaListagemGeradores items={ordem.items}  />
            <div className='w-100 d-flex align-items-center justify-content-center'>
                <Button color='success bg-gradient' onClick={salvarManutencao}><FontAwesomeIcon icon={faSave} /> Salvar</Button>
            </div>
        </MainCard >
    )
}